<template>
  <section v-if="filas.length" class="ut-asignacion-lista" :aria-label="titulo">
    <h3>{{ titulo }}</h3>
    <div class="ut-asignacion-tabla" tabindex="0">
      <table><thead><tr><th>Envio</th><th>Resultado</th><th>Motivo</th></tr></thead>
        <tbody><tr v-for="fila in filas" :key="fila.id"><td>{{ fila.noEnvio || fila.id }}</td><td>{{ estados[fila.estado] || fila.estado }}</td><td>{{ fila.motivo }}</td></tr></tbody>
      </table>
    </div>
  </section>
</template>
<script>
export default {
  name: 'ListaAsignacionEnvios',
  props: { filas: { type: Array, default: () => [] }, titulo: { type: String, required: true } },
  data: () => ({ estados: { MODIFICADO: 'Modificado', OMITIDO: 'Omitido', DESMARCADO: 'Desmarcado', COMPATIBLE: 'Compatible', PENDIENTE: 'Pendiente' } }),
};
</script>
<style scoped>
.ut-asignacion-lista { margin-top: 16px; color: #263644; letter-spacing: 0; }
.ut-asignacion-lista h3 { font-size: 14px; line-height: 1.4; margin: 0 0 8px; }
.ut-asignacion-tabla { max-height: 300px; overflow: auto; }
.ut-asignacion-tabla table { border-collapse: collapse; width: 100%; table-layout: fixed; font-size: 13px; }
.ut-asignacion-tabla th, .ut-asignacion-tabla td { padding: 8px; text-align: left; border-bottom: 1px solid #d5dce1; vertical-align: top; overflow-wrap: anywhere; }
.ut-asignacion-tabla th { position: sticky; top: 0; background: #edf2f5; }
.ut-asignacion-tabla th:first-child { width: 27%; }
.ut-asignacion-tabla th:nth-child(2) { width: 22%; }
@media (max-width: 600px) {
  .ut-asignacion-tabla th:first-child { width: 34%; }
  .ut-asignacion-tabla th:nth-child(2) { width: 32%; }
}
</style>
